import React from 'react'
import { styled } from '@mui/material/styles'
import { Button, FormDataConsumer, FormTab, useTranslate } from 'react-admin'
import BriefPdfRenderer from '../EventsComponents/BriefPdfRenderer'
import { EventFormDataConsumerProps } from './GeneralTab'
import { printReactComponent } from 'services/pdf-print/pdf-print'
import { serviceDiscriminatorArray } from 'services/cfg/form'
import { Divider } from '@mui/material'

const PREFIX = 'BriefRecapTab'

const classes = {
  marginY: `${PREFIX}-marginY`,
  bold: `${PREFIX}-bold`,
}

const StyledFormTab = styled(FormTab)({
  [`& .${classes.marginY}`]: {
    margin: '16px 0',
  },
  [`& .${classes.bold}`]: {
    fontWeight: 'bold',
  },
})

const BriefRecapTab: React.FC = (props) => {
  const translate = useTranslate()

  return (
    <StyledFormTab {...props} label="Event Brief">
      <FormDataConsumer>
        {({ formData }: EventFormDataConsumerProps) => {
          if (!formData.surveyResponses?.length)
            return <div>...no responses have been submitted yet</div>

          return (
            <React.Fragment>
              {formData.surveyResponses.map(
                ({ supplieredService, questionResponses }, idx) => (
                  <div
                    key={`question_header_${idx}`}
                    className={classes.marginY}
                  >
                    <h2>
                      {(serviceDiscriminatorArray as string[]).includes(
                        supplieredService
                      )
                        ? translate(`form.headers.${supplieredService}`)
                        : supplieredService}
                    </h2>
                    {questionResponses?.map(({ question, response }, idx) => (
                      <div
                        key={`question_values_${idx}`}
                        className={classes.marginY}
                      >
                        <div className={classes.bold}>{question}</div>
                        <div className={classes.marginY}>{response}</div>
                      </div>
                    ))}
                    <Divider />
                  </div>
                )
              )}

              <Button
                label="Download Pdf"
                variant="contained"
                onClick={printReactComponent(
                  BriefPdfRenderer({
                    eventInfo: formData,
                    surveyResponses: formData.surveyResponses,
                  }) as JSX.Element
                )}
              />
            </React.Fragment>
          )
        }}
      </FormDataConsumer>
    </StyledFormTab>
  )
}

export default BriefRecapTab
